import { IconButton, makeStyles, styled, Tab, Tabs, withStyles } from "@material-ui/core";
import { Button, colors, Column, div, PopupDialog, PrimaryButton, span } from "lqx-react";
import React from "react";
import { preventDefaultAndStopPropagation } from "../shared";

export const Body = div({
    borderTopLeftRadius: '5px',
    borderTopRightRadius: '5px',
    padding: '5px 10px 5px 10px',
    width: '100%',
    height: '60px',
    background: '#FFFFFF',
    backgroundColor: (props: any) => props.active === 'true' ? '#F4FAFD' : '#FFFFFF',
});

export const Footer = div({
    width: '100%',
    borderTop: '2px solid #F2F5F8',
    borderLeft: '1px solid #F2F5F8',
    borderRight: '1px solid #F2F5F8',
    fontWeight: 500,
    fontSize: '12px',
    minHeight: '28px',
    padding: '5px 5px 0px 10px',
    overflow: 'hidden',
    borderBottomLeftRadius: '5px',
    borderBottomRightRadius: '5px',
    backgroundColor: (props: any) => props.active === 'true' ? '#E7F2F9' : '#F9FAFC',
    color: '#3E4B5F',
    display: 'flex',
    flexWrap: 'wrap'
});

export const Container = div({
    borderRadius: '5px',
    width: '95%',
    maxWidth: '95%',
    height: '90px',
    overflow: 'hidden',
    border: (props: any) => props.active === 'true' ? '1px solid #58C1EE' : '1px solid #F2F5F8'
});

export const FooterLabel = div({
    fontWeight: 'normal',
    fontSize: '12px',
    color: '#829AB0'
});

export const FooterContent = div({
    flex: '0 0 auto',
    minWidth: '20px'
});

export const FooterRow = div({
    display: 'flex',
    flexDirection: 'row',
    gap: '8px'
});

export const Row = div({
    width: '100%',
    marginBottom: '15px'
});

export const PolicyName = span({
    color: '#bbc3cc',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '12px',
    marginLeft: '5px'
});

export const PolicyCardDate = div({
    marginLeft: '3px',
    color: 'black',
    fontSize: '13px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '16px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth: '100%'
});

export const AssetTypeName = span({
    marginLeft: '5px',
    color: 'black',
    fontSize: '13px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '16px'
});

export const ModifyLabel = span({
    marginLeft: '5px',
    color: '#f27324',
    fontSize: '13px',
    fontStyle: 'normal',
    lineHeight: '16px'
});

export const State = span({
    color: '#63a9dc',
    fontSize: '13px',
    fontWeight: 500,
    textAlign: 'left',
    lineHeight: '16px',
    paddingLeft: '3px'
});

export const NameBlock = div({
    padding: '5px 0px'
});

export const NameLabel = span({
    color: '#829AB0',
    fontWeight: 'normal',
    fontSize: '12px',
});

export const NavigateTemplateLink = span({
    color: colors.blue,
    cursor: 'pointer',
    fontWeight: 500
});

export const StyledIconButton = styled(IconButton)({
    margin: 0,
    padding: 0
})

export const StatusDialog = ({ $isOpen, onClick, text, title }) => {
    const handleCloseShowErrors = (_, reason) => {
        if (reason === 'clickaway') return;
        $isOpen.set(false);
    };

    return (
        $isOpen.value ?
            <PopupDialog
                title={title}
                actions={
                    <>
                        <Button onClick={(e) => { preventDefaultAndStopPropagation(e); $isOpen.set(false) }}>Cancel</Button>
                        <PrimaryButton onClick={onClick}>Yes</PrimaryButton>
                    </>
                }
                hideTitle={false}
                disabled={false}
                onClose={handleCloseShowErrors}>
                {text}
            </PopupDialog> : <></>
    )
}

export const ButtonsBlock = div({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center'
});

export const TilesListColumn = styled(Column)({
    minWidth: '500px',
    minHeight: '250px',
});

export const DetailsPaneColumn = styled(Column)({
    maxWidth: '625px'
});

export const DetailsPaneTabContent = div({
    border: '1px solid #E2F0F7',
    marginTop: '10px',
    fontSize: '13px',
    fontWeight: 500,
    lineHeight: '15px',
});

export const DetailsPaneContainer = div({
    backgroundColor: 'white',
    padding: '0px'
});

export const DetailsPaneActionsContainer = div({
    paddingRight: '30px'
});

export const DetailsPaneHeader = div({
    display: 'contents',
    width: '100%',
    height: '100%',
    border: '1px solid #E2F0F7',
    paddingTop: 0
});

export const DetailsPaneStatus = div({
    color: '#63a9dc',
    height: '15px',
    marginLeft: '21px',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '15px',
});

export const DetailsPaneTabs = withStyles({
    indicator: {
        display: 'none'
    },
    root: {
        marginTop: '8px'
    }
})((props: any) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

export const DetailsPaneTab = withStyles({
    root: {
        width: '73px',
        minWidth: '73px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        padding: '3px 10px 6px',
        position: 'static',
        height: '26px',
        left: '46.58px',
        background: (props: any) => props.selected ? '#DCEEFD' : 'white',
        fontWeight: (props: any) => props.selected ? 600 : 400,
        borderRadius: '4px',
        flex: 'none',
        margin: '0px 20px',
        textTransform: 'none'
    },
})((props: any) => <Tab disableRipple {...props} />);

export const colorStyles = makeStyles({
    chipLabel: {
        color: colors.green
    },
    standardChipColor: {
        color: colors.blue
    },
    active: {
        color: colors.blue
    },
    inactive: {
        color: colors.red
    }
});

export const detailsPanelStyles = makeStyles({
    iconButton: {
        display: 'block',
        marginLeft: 'auto',
        marginTop: '10px',
        marginRight: '10px',
    },
    sectionTitle: {
        color: '#63a9dc',
        fontSize: '13px',
        marginRight: '1em',
        display: 'flex',
        alignItems: 'center'
    }
});
